module.exports = __webpack_public_path__ + "img/wix_3.64cdd54a.png";